import React from "react";
import Img from "gatsby-image";
import {isMobile} from 'react-device-detect';
import BackButtons from "../common/backbuttons";

class MainGalleryInstagramSection extends React.Component {

    componentDidMount() {
        if(typeof window !== 'undefined' && !isMobile) {

            this.sliderContent.style.overflow = (typeof window !== 'undefined' && isMobile) ? 'scroll visible' : 'hidden';

            this.goback.addEventListener("mouseover", this.handleBackScrolling);
            this.goforward.addEventListener("mouseover", this.handleForwardScrolling);
            this.goback.addEventListener("mouseleave", this.stopBackScrolling);
            this.goforward.addEventListener("mouseleave", this.stopForwardScrolling);

            this.goback.style.display='visible';
            this.goforward.style.display='visible';
        }
        if(typeof window !== 'undefined' && isMobile) {
            this.goback.style.display='none';
            this.goforward.style.display='none';
        }
    }
    
    componentWillUnmount() {
        if(typeof window !== 'undefined' && !isMobile) {
            this.goback.removeEventListener("mouseover", this.handleBackScrolling);
            this.goforward.removeEventListener("mouseover", this.handleForwardScrolling);
            this.goback.removeEventListener("mouseleave", this.stopBackScrolling);
            this.goforward.removeEventListener("mouseleave", this.stopForwardScrolling);

            this.goback.style.display='hidden';
            this.goforward.style.display='hidden';
        }
        if(typeof window !== 'undefined' && isMobile) {
            this.goback.style.display='none';
            this.goforward.style.display='none';
        }
    }

    handleBackScrolling = () => {
        var self=this
        this.timeoutLeft = setInterval(function() {
            self.sliderContent.scrollLeft-=3
        }.bind(this), 5)
    }
    handleForwardScrolling = () => {
        var self=this
        this.timeoutRight = setInterval(function() {
            self.sliderContent.scrollLeft+=3
        }.bind(this), 5)
    }
    stopBackScrolling = () => {
        clearInterval(this.timeoutLeft)
    }
    stopForwardScrolling = () => {
        clearInterval(this.timeoutRight)
    }

    constructor(props) {
        super(props)

        this.setSliderContentRef = element => {
            this.sliderContent = element;
        };
        this.setSliderGoBackRef = element => {
            this.goback = element;
        };
        this.setSliderGoForwardRef = element => {
            this.goforward = element;
        };
    }

    transformCaptionText(strCaption) {
        const maxLength = 100
        let shortCaption = ''


        let textParts = strCaption.replace(/[\n\.]+\s+#(.*)/mg,'').split(/\s+/mg)

        while (textParts.length) {
            let nextWord = textParts.shift()

            if (shortCaption.length + nextWord.length < maxLength - 1) {
                shortCaption += ' ' + nextWord
            } else {
                shortCaption = shortCaption.trim() + '...'
                break;
            }
        }
        return shortCaption
    }

    render() {
        const { mediadata } = this.props
        return (
            <section className="wrapper style1 align-center">
                <div className="inner">
                    <a href="https://instagram.com/gadaabout" target="_blank"><h2>Instagram feed</h2></a>
                    <p>I miei ultimi 10 post su <a href="https://instagram.com/gadaabout" target="_blank">Instagram</a>, se avete voglia di lasciare un commento: così l'engagement rate si impenna <i className="fa fa-thumbs-o-up"></i></p>
                </div>

                <div id="MainGalleryInstagramSection" className="gallery style2 medium lightbox onscroll-fade-in">
                    <div className="backward" ref={this.setSliderGoBackRef}></div>
                    <div className="forward" ref={this.setSliderGoForwardRef}></div>
                    <div id="MainGalleryInstagramSectionContent" className="inner" 
                         ref={this.setSliderContentRef} >
                    {mediadata.edges.map(({ node: igPost },index) => (
                        <article key={index}>
                            <a href={igPost.link} className="image" target="_blank">
                                <Img fluid={igPost.localImage.childImageSharp.fluid}/>
                            </a>
                            <div className="caption">
                                <h3>{igPost.location != null ? igPost.location.name : "☺"}</h3>
                                <p>{this.transformCaptionText(igPost.caption.text)}</p>
                                <ul className="actions fixed">
                                    <li><a href={igPost.link} target="_blank" className="image"><span className="button small">Scopri</span></a></li>
                                </ul>
                            </div>
                        </article>
                    ))}
                    </div>
                </div>
                <BackButtons backElement="mapElements"/>
            </section>
        )
    }
}

export default MainGalleryInstagramSection